import { render, staticRenderFns } from "./CrewCard.vue?vue&type=template&id=a5e16cc4&scoped=true&"
import script from "./CrewCard.vue?vue&type=script&lang=js&"
export * from "./CrewCard.vue?vue&type=script&lang=js&"
import style0 from "./CrewCard.vue?vue&type=style&index=0&id=a5e16cc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e16cc4",
  null
  
)

export default component.exports